import React from 'react';
interface QuizProgressProps {
  currentStep: number;
  totalSteps: number;
}
const QuizProgress: React.FC<QuizProgressProps> = ({
  currentStep,
  totalSteps
}) => {
  const progress = Math.round(currentStep / (totalSteps - 1) * 100);
  return <div className="w-full" data-id="element-232">
      <div className="flex justify-between text-xs text-gray-400 mb-2" data-id="element-233">
        <span data-id="element-234">
          Fråga {currentStep + 1} av {totalSteps}
        </span>
        <span data-id="element-235">{progress}% klart</span>
      </div>
      <div className="w-full h-2 bg-gray-800 rounded-full overflow-hidden" data-id="element-236">
        <div className="h-full bg-[#0EB7FF] transition-all duration-300 ease-out" style={{
        width: `${progress}%`
      }} data-id="element-237"></div>
      </div>
    </div>;
};
export default QuizProgress;